import React from 'react';

import { withStyles } from '@material-ui/core/styles';

import clsx from 'clsx';

import styles from './styles';

export const PanelBody = props => {
  const { classes, className, children, ...other } = props;

  if (!children) return null;

  return (
    <div
      data-testid="panel-body"
      className={clsx(classes.root, className)}
      {...other}
    >
      {children}
    </div>
  );
};

export default withStyles(styles)(PanelBody);
